import { lazy } from 'react';


export const AfterCoursesPage = lazy(() => import('./AfterCoursesPage'));
